import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Billing - Payment Details</Typography>
      <p>This is where you register a payment card for our pay-as-you-go tariffs.</p>
      <p> You do not need a payment card for out FREE Tier. If you are one of our paid
      for tiers and you downgrade to the FREE Tier then we will automatically delete your 
      payment card.
      </p>

      <p>We do not hold your card details. We use a professional payment processing company (Stripe). 
        When you add a card, the form submits your car ddetails directly to them. We never see
        your card details. The only thing we store is a reference that Stripe give to us. You
        can be sure that your card details are held as securely as possible.</p>

      <p>When you upgrade from our FREE Tier to a paid plan we will need to charge you for your first
        month immediately. 
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Add a payment card</Typography>
      <p>To add a payment card, click the [ADD A PAYMENT CARD] button. Stripe's form will
        open in a panel on the right. Compelete that form and submit.
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Expired card</Typography>
      <p>If your payment card has expired or is expiring soon, that will be cleared shown here.
      </p>


    </div>
  )
}

export default HelpText